module.exports = __webpack_public_path__ + "static/images/75be87755eb0fb43e60d5004fee4680a.svg";